import {
  CREATE_LEAD_CAPTURE,
  CREATE_LEAD_CAPTURE_SUCCESS,
  CREATE_LEAD_CAPTURE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const createLeadCaptureReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_LEAD_CAPTURE:
      return { ...state, loading: true };
    case CREATE_LEAD_CAPTURE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_LEAD_CAPTURE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default createLeadCaptureReducer;
